export const DOCTORS_AGENT_FEATURES = [
  {
    title: 'Votre cabinet répond aux patients en moins de 5 secondes, jour et nuit',
    body: "Sur WhatsApp, Instagram et Facebook, dans leur langue. Le premier cabinet qui répond gagne le patient. Avec ce système, c'est toujours vous.",
  },
  {
    title: 'Smile Gen : le patient voit son sourire avant de venir',
    body: "Le patient peut visualiser une première piste avant le rendez-vous. Smile Gen est inclus pour les six cabinets pilotes accompagnés dans chaque ville.",
  },
  {
    title: 'Le système qualifie le patient et prend le rendez-vous tout seul',
    body: "Il suit vos services, vos prix et votre façon de travailler. Votre agenda se remplit sans vous. Votre assistante n'intervient que si c'est vraiment utile.",
  },
  {
    title: 'Vous voyez tout, sans y passer de temps',
    body: 'Vous savez ce qui se passe dans chaque message et chaque rendez-vous. Pas besoin de tout lire ni de courir après votre assistante. Vous gardez le contrôle et vous gagnez du temps.',
  },
] as const

export const DOCTORS_AGENT_FAQS = [
  {
    question: "Est-ce que l'agent répond comme une vraie assistante du cabinet ?",
    answer: "Oui. Nous le configurons à partir de conversations locales rédigées par de vraies assistantes de cabinets. Il apprend le vocabulaire du métier, la façon dont vos patients posent leurs questions et le ton que vous souhaitez employer. Ses réponses restent naturelles tout en respectant les informations et les règles de votre cabinet.",
  },
  {
    question: "Que se passe-t-il lorsqu'une demande nécessite une intervention humaine ?",
    answer: "L'agent ne cherche pas à improviser. Lorsqu'une demande sort de son périmètre, qu'un patient insiste ou qu'une décision doit être prise par votre équipe, il transmet la conversation à une personne. Votre assistante reçoit le contexte utile et peut reprendre l'échange sans demander au patient de tout répéter.",
  },
  {
    question: 'Comment vérifier que les demandes sont bien suivies ?',
    answer: "Vous recevez chaque jour un rapport qui indique le nombre de messages traités, les conversations transférées à votre équipe et les demandes qui attendent encore une réponse. Vous pouvez ainsi contrôler le travail effectué sans relire toutes les conversations une par une.",
  },
  {
    question: 'Les données de mes patients sont-elles protégées ?',
    answer: "Forteuno Web est partenaire officiel Meta et utilise les connexions officielles pour WhatsApp, Instagram et Messenger, avec des échanges chiffrés. Nous évitons les méthodes non officielles qui peuvent exposer ou faire suspendre un compte. Après la création de votre espace, vous changez vos identifiants et seuls vous et les membres de votre équipe que vous autorisez peuvent accéder aux données.",
  },
  {
    question: "Peut-on améliorer l'agent après sa mise en ligne ?",
    answer: "Oui, et ce suivi fait partie de notre contrat. Vous pouvez nous signaler une réponse à corriger, une nouvelle consigne ou une préférence propre au cabinet. Notre équipe traite chaque demande d'amélioration dans un délai inférieur à trois jours afin que l'agent évolue avec votre façon de travailler.",
  },
] as const
